import { useTranslation } from "react-i18next";
import { useAppSelector } from "src/common/state/hooks";
import { FooterButtons } from "../../../common/components/FooterButtons";
import type { IMedia } from "../../../model/unityObject";
import { getFilteredMedias } from "../state/gallerySlice";
import { useMediaById } from "../useMediaById";
import { useTourView } from "../../onboarding/engine/useTourView";
import { TOUR_VIEW_ANCHORS } from "../../onboarding/engine/tourViewAnchors";

export const Actions = ({
  selectedMediaId,
  onConfirm,
  onCancel,
}: {
  selectedMediaId: number;
  onConfirm: (media: IMedia) => void;
  onCancel: () => void;
}) => {
  const { t } = useTranslation();
  useTourView("media-gallery", true, TOUR_VIEW_ANCHORS["media-gallery"]);

  const listedMedia = useAppSelector((state) =>
    getFilteredMedias(state).find((media) => Number(media.id) === Number(selectedMediaId)),
  );
  const { media: fetchedMedia } = useMediaById(
    selectedMediaId > 0 && !listedMedia ? selectedMediaId : undefined,
  );
  const selectedMedia = listedMedia ?? fetchedMedia;

  return (
    <FooterButtons
      cancelText={t("general.cancel")}
      cancelCb={onCancel}
      nextText={t("general.confirm")}
      nextCb={() => {
        if (selectedMedia) {
          onConfirm(selectedMedia);
        }
      }}
      nextDataTour="media-gallery-confirm"
    />
  );
};
